import { Cover } from "@/interfaces/api";
import { useGetToken } from "./token";
import queryClient from "@/lib/queryClient";

const getCover = async (q: number) => {
  const response = await fetch(`/api/get-cover?q=${q}`);
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  const data: Cover = await response.json();
  return data;
};

export const useGetCover = () => {
  const { data, refetch } = useGetToken();

  const fetchCover = async (q: number) => {
    if (!data?.hasToken) await refetch();

    const cover = await queryClient.fetchQuery({
      queryKey: ["getCover", q],
      queryFn: async () => {
        const result = await getCover(q);
        return result;
      },
    });

    return cover;
  };

  return { fetchCover };
};
